import { Injectable, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class ErrorDisplayService {
  private readonly translate = inject(TranslateService);
  private readonly toastrService = inject(ToastrService);

  showError(error: Error | string): void {
    const errorMessage = typeof error === 'string' ? error : error.message;
    const message = `<h2>${this.translate.instant('error_toast.message')}</h2>
    <ul>
      <li>${errorMessage || error}</li>
    </ul>
    `;

    this.toastrService.error(message, this.translate.instant('error_toast.title'), {
      positionClass: 'toast-top-full-width',
      timeOut: 5000,
      progressBar: true,
      enableHtml: true, // Required for the HTML in the message
    });
  }
}
